/**
 * useShipmentsKanbanRealtime - Canal único por tenant para a tabela `shipments`.
 *
 * Qualquer mudança invalida as consultas de remessas (colunas e totais), fazendo
 * os cards trocarem de coluna sozinhos. RLS restringe ao tenant ativo.
 *
 * RELEASE: 2026-10-16 v1.0.0 - Versão inicial (Kanban de Remessas).
 */
import { useEffect } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { useAuth } from '@/hooks/useAuth';
import { createLogger } from '@/lib/logger';

const logger = createLogger('ShipmentsKanbanRealtime');

export function useShipmentsKanbanRealtime(enabled = true) {
  const { currentTenant } = useAuth();
  const qc = useQueryClient();
  useEffect(() => {
    if (!enabled || !currentTenant?.id) return;
    const tenantId = currentTenant.id;
    const channel = supabase
      .channel(`shipments-kanban-${tenantId}`)
      .on('postgres_changes', { event: '*', schema: 'public', table: 'shipments', filter: `tenant_id=eq.${tenantId}` }, () => {
        qc.invalidateQueries({ queryKey: ['shipments', tenantId] });
        qc.invalidateQueries({ queryKey: ['shipment', tenantId] });
        // Mudança feita por outro usuário também atualiza a linha do tempo aberta.
        qc.invalidateQueries({ queryKey: ['shipment-timeline'] });
        // A situação da O.S. vinculada segue a remessa (gatilho no servidor)
        qc.invalidateQueries({ queryKey: ['service-orders'] });
      })
      .subscribe((status) => { if (status === 'CHANNEL_ERROR') logger.warn('Falha no canal de remessas'); });
    return () => { supabase.removeChannel(channel); };
  }, [enabled, currentTenant?.id, qc]);
}
